import type React from 'react';
import { useCallback, useEffect, useState } from 'react';

import { useLDClient } from 'launchdarkly-react-client-sdk';

import { useUser } from '@cobliteam/hooks';

import LoadingPage from '../pages/LoadingPage';

interface FeatureFlagsProviderProps {
  children: React.ReactNode;
}

const FeatureFlagsProvider = ({ children }: FeatureFlagsProviderProps) => {
  const ldClient = useLDClient();
  const [initialized, setInitialized] = useState(false);

  const { session, useGetUserData } = useUser();
  const { data: user } = useGetUserData(session?.user.id, !!session);

  const ldClientIdentify = useCallback(async () => {
    if (ldClient && user && session) {
      await ldClient.identify({
        key: session.user.email,
        custom: {
          fleet_name: session.fleet.name,
          fleet_id: session.fleet.id,
          num_devices: user.userAttributes.numberOfDevices,
          creation_date: user.userAttributes.creationDate,
          age_in_days: user.userAttributes.ageInDays,
        },
      });

      setInitialized(true);
    }
  }, [ldClient, user, session]);

  useEffect(() => {
    ldClientIdentify();
  }, [ldClientIdentify]);

  if (!initialized) return <LoadingPage showLogo message='Carregando configurações do sistema...' />;

  return children;
};

export default FeatureFlagsProvider;
